<!-- SMT微信公众号弹框 -->
<template>
  <el-dialog
    width="480px"
    top="20%"
    title="提示"
    append-to-body
    :visible="isShow"
    :lock-scroll="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    class="patch-dialog"
    @close="handleClose"
  >
      <el-form class="dialog-content" size="small" label-width="120px">
        <div class="title">
          系统检测到关联PCB订单数量调整为{{pcbNumber}}片，请相应修改SMT生产套数
        </div>
      </el-form>
       <span slot="footer" class="dialog-footer">
          <el-button size="medium" class="submit-btn" @click="handleConfirm">返回上一页修改</el-button>
      </span>
  </el-dialog>
</template>

<script>
import { pcsNumForSet } from '@@/utils/pcbParamsFormat'
export default {
  components: {
  },
  props: {
  
  },
  data() {
    return {
      isShow: false,
      pcbNumber:0,
      number:0
    }
  },
 
  computed: {
  
  },
  methods: {
    open(info) {
      try {
        this.pcbNumber = pcsNumForSet(info)
        this.number = info.number
        this.isShow = true
      } catch (error) {
        console.error(error)
      }
    },
    handleClose() {
      this.isShow = false
    },
   
    handleConfirm(){
      this.$emit('onComfirm',{})
    }
  },
}
</script>

<style lang="scss" scoped>
.patch-dialog {
  ::v-deep .el-dialog__body {
    padding: 30px 24px;
    padding-top:0px;
  }
}
.content{
  margin-top:15px;
}
.title{
  font-size: 16px;
  color:#666;
}
.submit-btn {
  background-color: #15a675;
  border-color: #15a675;
  color: #fff;

  &:hover {
    background-color: #128a63;
    border-color: #128a63;
  }

  &:focus {
    background-color: #15a675;
    border-color: #15a675;
  }
}
</style>
